import {
  Grid,
  MultiSelect,
  PasswordInput,
  TextInput,
} from "@mantine/core";
import { FormikProps } from "formik";
import { FC } from "react";
import { ROLE_OPTIONS } from "constants/common/user";

interface UserFormFieldsProps {
  formik: FormikProps<any>;
  isPasswordReset: boolean;
  isCreateMode: boolean;
}

const spanStyle = { base: 12, md: 6 };

const UserFormFields: FC<UserFormFieldsProps> = ({
  formik,
  isPasswordReset,
  isCreateMode,
}) => {
  const getFieldError = (fieldName: string) => {
    return formik.touched[fieldName] && formik.errors[fieldName]
      ? (formik.errors[fieldName] as string)
      : null;
  };

  if (isPasswordReset)
    return (
      <Grid>
        <Grid.Col span={{ base: 12, md: 12 }}>
          <PasswordInput
            label="Mật khẩu"
            placeholder="Nhập mật khẩu"
            withAsterisk
            {...formik.getFieldProps("password")}
            error={getFieldError("password")}
          />
        </Grid.Col>
      </Grid>
    );

  return (
    <Grid>
      {/* Row 1 */}
      <Grid.Col span={spanStyle}>
        <TextInput
          label="Tên đăng nhập"
          placeholder="Nhập tên đăng nhập"
          withAsterisk
          disabled={!isCreateMode} // Disable username for edit form
          {...formik.getFieldProps("username")}
          error={getFieldError("username")}
        />
      </Grid.Col>

      {isCreateMode && (
        <Grid.Col span={spanStyle}>
          <PasswordInput
            label="Mật khẩu"
            placeholder="Nhập mật khẩu"
            withAsterisk
            {...formik.getFieldProps("password")}
            error={getFieldError("password")}
          />
        </Grid.Col>
      )}

      {/* Row 2 */}
      <Grid.Col span={spanStyle}>
        <TextInput
          label="Họ và tên"
          placeholder="VD: Trần Thị B"
          disabled={!isCreateMode}
          withAsterisk
          {...formik.getFieldProps("fullname")}
          error={getFieldError("fullname")}
        />
      </Grid.Col>

      <Grid.Col span={spanStyle}>
        <TextInput
          label="Số điện thoại"
          placeholder="VD: 0909999999"
          {...formik.getFieldProps("phone")}
          error={getFieldError("phone")}
        />
      </Grid.Col>

      {/* Row 3 */}
      <Grid.Col span={spanStyle}>
        <MultiSelect
          label="Vai trò (Roles)"
          placeholder="Chọn quyền truy cập"
          data={ROLE_OPTIONS}
          searchable
          value={formik.values.roles}
          onChange={(value) => formik.setFieldValue("roles", value)}
          onBlur={() => formik.setFieldTouched("roles", true)}
          error={getFieldError("roles")}
        />
      </Grid.Col>
    </Grid>
  );
};

export default UserFormFields;
